import { HTTPB2B } from 'providers'

export class UserRoleService extends HTTPB2B {
  private endpoint = '/user-role'

  public fetchAll() {
    return this.get({ endpoint: this.endpoint })
  }
}
